import VueI18n from 'vue-i18n';
import Vue from 'vue';
import en from '@/locales/en.json';

Vue.use(VueI18n);
export const i18n = new VueI18n({
  locale: process.env.VUE_APP_I18N_LOCALE || 'en', // set
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'en',
  messages: {en}, // set locale messages
});
